import * as types from "../types/index";
import { core } from "./core";

export const getUserGroups = () => {
  return core.API(
    "GET",
    `/groups?limit=200&offset=0`,
    types.GET_USER_GROUPS,
    types.GET_USER_GROUPS_SUCCESS,
    types.GET_USER_GROUPS_FAILURE
  );
};

export const getUserGroupList = () => {
  return core.API(
    "GET",
    `/groups?limit=200&offset=0&users_count=true`,
    types.GET_USER_GROUPS,
    types.GET_USER_GROUPS_SUCCESS,
    types.GET_USER_GROUPS_FAILURE
  );
};

export const getUserGroupDetails = (id) => {
  return core.API(
    "GET",
    `/group/${id}`,
    types.GET_USER_GROUP_DETAILS,
    types.GET_USER_GROUP_DETAILS_SUCCESS,
    types.GET_USER_GROUP_DETAILS_FAILURE
  );
};

export const createUserGroups = (data) => {
  return core.API(
    "POST",
    `/group`,
    types.CREATE_USER_GROUPS,
    types.CREATE_USER_GROUPS_SUCCESS,
    types.CREATE_USER_GROUPS_FAILURE,
    data
  );
};

export const deleteUserGroups = (id) => {
  return core.API(
    "DELETE",
    `/group/${id}`,
    types.DELETE_USER_GROUPS,
    types.DELETE_USER_GROUPS_SUCCESS,
    types.DELETE_USER_GROUPS_FAILURE
  );
};

export const putUserGroups = (id, data) => {
  return core.API(
    "PUT",
    `/group/${id}`,
    types.PUT_USER_GROUPS,
    types.PUT_USER_GROUPS_SUCCESS,
    types.PUT_USER_GROUPS_FAILURE,
    data
  );
};
